import type { SkuCardData } from "@/components/chat/SkuCard";

/** Lean vendor_products row shape used for checkout hydration. */
export interface VendorProductCheckoutRow {
  id: string;
  name: string;
  description: string | null;
  price: number | string | null;
  image_url: string | null;
  slug: string | null;
  vendor_category: string | null;
  lead_time_days: number | null;
  is_voucher: boolean | null;
  variant_label: string | null;
  dietary_tags: string[] | null;
  vendor_partners:
    | { vendor_name: string }
    | { vendor_name: string }[]
    | null;
}

/** Map a vendor_products SELECT row to SkuCardData for checkout surfaces. */
export function vendorProductToSkuCardData(
  row: VendorProductCheckoutRow,
): SkuCardData {
  const vendor = Array.isArray(row.vendor_partners)
    ? row.vendor_partners[0]
    : row.vendor_partners;
  const isVoucher = Boolean(row.is_voucher);

  return {
    sku_id: row.id,
    name: row.name,
    vendor_name: vendor?.vendor_name ?? "Lembra",
    vendor_category: row.vendor_category ?? "gift",
    price_aud: Number(row.price ?? 0),
    image_url: row.image_url,
    slug: row.slug ?? row.id,
    description: row.description,
    is_voucher: isVoucher,
    price_prefix_from: isVoucher && Boolean(row.variant_label),
    lead_time_days: row.lead_time_days,
    dietary_tags: row.dietary_tags,
    highlight_fields: [],
  };
}
